// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/config-provider/style/index.less
// module id = 494
// module chunks = 0